import React, { createContext, useContext, useState } from "react";
import AttachmentsModal from "../modals/AttachmentsModal";
import BindEndoQuoteModal from "../modals/BindEndoQuoteModal";
import BindQuoteModal from "../modals/BindQuoteModal";
import BindQuoteSuccessModal from "../modals/BindQuoteSuccessModal";
import CancelEndorsementModal from "../modals/CancelEndorsementModal";
import ChangeCommissionModal from "../modals/ChangeCommissionModal";
import CreateClauseModal from "../modals/CreateClauseModal";
import CreateEndoWarningModal from "../modals/CreateEndoWarningModal";
import CreateProductModal from "../modals/CreateProductModal";
import CreateSchemaModal from "../modals/CreateSchemaModal";
import DeclineContractModal from "../modals/DeclineContractModal";
import DownloadBdxModal from "../modals/DownloadBdxModal";
import EditBespokeModal from "../modals/EditBespokeModal";
import EditClauseModal from "../modals/EditClauseModal";
import EditQuoteWarningModal from "../modals/EditQuoteWarningModal";
import NotProgressedModal from "../modals/NotProgressedModal";
import NotTakenUpModal from "../modals/NotTakenUpModal";
import ProcessReferralModal from "../modals/ProcessReferralModal";
import ReferContractModal from "../modals/ReferContractModal";
import SubmitBespokeEndorsementModal from "../modals/SubmitBespokeEndorsementModal";
import SubmitEndorsementModal from "../modals/SubmitEndorsementModal";
import SubmitRenewalBespokeModal from "../modals/SubmitRenewalBespokeModal";
import UnsavedChangesModal from "../modals/UnsavedChangesModal";

const modalsMap = {
  AttachmentsModal,
  BindEndoQuoteModal,
  BindQuoteModal,
  BindQuoteSuccessModal,
  CancelEndorsementModal,
  ChangeCommissionModal,
  CreateClauseModal,
  CreateEndoWarningModal,
  CreateProductModal,
  CreateSchemaModal,
  DeclineContractModal,
  DownloadBdxModal,
  EditBespokeModal,
  EditClauseModal,
  EditQuoteWarningModal,
  NotProgressedModal,
  NotTakenUpModal,
  ProcessReferralModal,
  ReferContractModal,
  SubmitEndorsementModal,
  SubmitBespokeEndorsementModal,
  SubmitRenewalBespokeModal,
  UnsavedChangesModal,
};

const ModalContext = createContext();

const useModal = () => useContext(ModalContext);

export const ModalContextProvider = ({ children }) => {
  const [modal, setVisibleModal] = useState();
  const [props, setProps] = useState();

  const showModal = (name, nextProps) => {
    setVisibleModal(name);
    setProps(nextProps);
  };
  const closeModal = () => setVisibleModal(undefined);

  return (
    <ModalContext.Provider value={{ modal, showModal, closeModal, props }}>
      {children}
    </ModalContext.Provider>
  );
};

export const ModalSwitch = () => {
  const { modal, closeModal, props } = useModal();
  const Component = modalsMap[modal];

  if (!Component) {
    return false;
  }

  return <Component handleClose={closeModal} {...props} />;
};

export default useModal;
